<template>
  <div>
    <el-upload
      :disabled="disable"
      ref="upload"
      :http-request="upload"
      class="upload-demo"
      :file-list="value"
      :on-remove="removeFile"
      :on-exceed="fileExceed"
      :before-upload="fileLimitFn"
      :limit="limit"
      :on-success="fileSuccess"
      :on-error="fileError"
      :on-preview="handlePreview"
      list-type="text"
      action="#"
      multiple
    >
      <slot name="upload-icon">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-upload"
          :disabled="disabled"
          >点击上传</el-button
        >
      </slot>
      <div class="el-upload__tip" slot="tip">
        <!-- <gaopaiyi @input="baseFileData"></gaopaiyi> -->
        {{ tip }}
      </div>
    </el-upload>
    <PreviewCom
      :show.sync="dialogVisible"
      :url="dialogImageUrl"
      :urlList="value"
      v-show="showPreview"
    ></PreviewCom>
  </div>
</template>
<script>
import { config } from "@/utils/axios";
import axios from "axios";
//import gaopaiyi from "./gaopaiyi.vue";
import { uploadFile } from "@/api/formList";
export default {
  name: "FileUpload",
  //components: { gaopaiyi },
  props: {
    showPreview: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      require: true,
      default: () => {
        return [];
      },
    },
    fileType: {
      type: String,
      default: () => {
        return "all";
      },
    },
    fileSize: {
      type: Number,
      default: () => {
        return 50;
      },
    },
    limit: {
      type: Number,
      default: () => {
        return 10;
      },
    },
    disable: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    needValid: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      progressFlag: true,
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  computed: {
    tip() {
      return `支持上传${
        this.fileType == "all"
          ? "任意格式"
          : this.fileType == "img"
          ? "图片类型"
          : "非图片类型"
      }文件，且单个文件不能超过${this.fileSize}MB，最多上传${this.limit}个文件`;
    },
    value: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update:data", val);
      },
    },
  },
  methods: {
    baseFileData(data) {
      let content = this.$dataURLtoFile(
        `data:image/png;base64,${data}`,
        `${new Date().getTime()}.png`
      );
      content.uid = new Date().getTime();
      let formData = new FormData();
      let fileType = this.$chargeImg(content.name) ? 2 : 1;
      formData.append("file", content);
      formData.append("fileType", fileType);
      uploadFile(formData).then((res) => {
        this.value.push({
          name: res.data.fileFullName,
          status: "success",
          url: res.data.url,
          fileType: res.data.fileType,
        });
      });
    },
    // 文件上传操作
    upload(file) {
      if (file.file.uid) {
        this.$fileReady[file.file.uid] = "ready";
        this.$store.commit("utils/SET_FILEREADY", this.$fileReady);
      }
      let type = this.$chargeImg(file.file.name) ? 2 : 1;
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("fileType", type);
      axios
        .post(`${config.proxy}/dynamic-form/store/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            appId: process.env.VUE_APP_APPID,
          },
          onUploadProgress: (progressEvent) => {
            let percent =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0;
            //调用onProgress方法来显示进度条，需要传递个对象 percent为进度值
            file.onProgress({ percent: percent });
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            file.onSuccess(res.data);
          } else {
            file.onError(res.data);
          }
        })
        .catch((error) => {
          file.onError(error);
        });
    },
    // 文件移除操作
    removeFile(file, fileList) {
      console.log(file);
      if (file.uid) {
        delete this.$fileReady[file.uid];
        this.$store.commit("utils/SET_FILEREADY", this.$fileReady);
      }
      this.value = fileList;
      this.needValid ? this.$emit("fileValid") : "";
    },
    // 上传前的限制
    fileLimitFn(file) {
      const fileSize = file.size / 1024 / 1024;
      // 类型限制
      if (this.fileType == "img" && !this.$chargeImg(file.name)) {
        this.$notify.warning(`非图片类型的文件不支持上传`);
        return false;
      } else if (this.fileType == "file" && this.$chargeImg(file.name)) {
        this.$notify.warning(`图片类型的文件不支持上传`);
        return false;
      }
      // 大小限制
      if (fileSize > this.fileSize) {
        this.$notify.warning(`${file.name}文件大小不得超过${this.fileSize}MB`);
        return false;
      }
    },
    // 文件超出个数限制
    fileExceed() {
      this.$notify.warning(`允许上传的最大个数${this.limit}个`);
    },
    // 文件上传成功
    fileSuccess(responese, file, fileList) {
      if (file.uid) {
        this.$fileReady[file.uid] = "success";
        this.$store.commit("utils/SET_FILEREADY", this.$fileReady);
      }
      file.url = responese.data.url;
      file.fileType = responese.data.fileType;
      delete file.status;
      delete file.raw;
      delete file.percentage;
      delete file.response;
      delete file.size;
      this.value = fileList;
      this.needValid ? this.$emit("fileValid") : "";
    },
    // 文件上传失败
    fileError(res, file) {
      if (file.uid) {
        delete this.$fileReady[file.uid];
        this.$store.commit("utils/SET_FILEREADY", this.$fileReady);
      }
      this.$notify.warning("上传文件失败");
    },
    // 文件预览
    handlePreview(file) {
      if (!file.url) {
        return;
        // let a = this.dataURLtoFile(file.content, `${new Date().getTime()}.png`);
        // let formData = new FormData();
        // let fileType = this.$chargeImg(a.name) ? 2 : 1;
        // formData.append("file", a);
        // formData.append("fileType", fileType);
        // uploadFile(formData).then((res) => {
        //   this.value.push({
        //     name: res.data.fileFullName,
        //     status: "success",
        //     url: res.data.url,
        //     fileType: res.data.fileType,
        //   });
        // });
      } else {
        let url = this.$operateUrl(file.url);
        if (this.$chargeImg(file.name)) {
          this.dialogImageUrl = url;
          this.dialogVisible = true;
        } else {
          if (file.name.toLowerCase().includes(".pdf")) {
            window.open(url);
          } else {
            this.$downLoadFn(file.name, url);
          }
        }
      }
    },
  },
};
</script>
